import React from 'react'

import { style, Container } from './Input.style'

const Input = ({
  className,
  style,
  label,
  type,
  contextThis,
  name,
  placeholder,
  required,
  textarea,
  isInvalid,
  parentObj = 'form',
}) => {
  const [focused, setFocused] = React.useState(false);
  const [value, setValue] = React.useState('');
  const showFloated = Boolean(focused||value);
  const props = {
    type: type || 'text',
    name,
    required,
    // placeholder: !focused?'':placeholder,
    placeholder: '',
    defaultValue: (contextThis.state[parentObj] && contextThis.state[parentObj][name]) || '',
  }

  const onFocus = () => {
    setFocused(true);
  }

  const onBlur = e => {
    setFocused(false);
    contextThis.setState({
      [parentObj]: {
        ...contextThis.state[parentObj],
        [name]: e.target.value,
      },
    })
  }

  const onChange = e => {
    setValue(e.target.value);
  }


  return (
    <Container className={className} style={style}>
      <div className={`label ${showFloated?'floated':''}`}>{label}
        {isInvalid?<span className="invalid__info">Please enter a valid email</span>:''}
      </div>
      <div className={textarea ? 'textareaWrapper' : 'inputWrapper'}>
        {textarea ? <textarea onFocus={onFocus} onChange={onChange} value={value} onBlur={onBlur} rows={2} {...props} /> : <input onChange={onChange} value={value} onFocus={onFocus} onBlur={onBlur} {...props} />}
      </div>

    </Container>
  )
}

export default Input
